export default "__VITE_ASSET__$Bbi8xTu__"